import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F845A",
      d: "M5.04 6.526H3.042c-.297 0-.388-.182-.2-.41l3.814-4.63c.185-.225.486-.22.67.01l3.665 4.612c.183.23.096.418-.2.418H8.758l-1.626 6.008c-.076.283-.207.279-.29 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }